module.exports = __webpack_public_path__ + "static/media/PlayBlack.af30ac40.svg";